module.exports = __webpack_public_path__ + "img/17878_L.dea0f088.png";